import request from '../../../../shared/request'

export function getOverview(filters) {
  return request(
    `/reports/general/activity-report/overview/?startDate=${filters.startDate}&endDate=${
      filters.endDate
    }`
  )
}

export function getOverviewByUser(filters) {
  return request(
    `/reports/general/activity-report/overview-by-user/?startDate=${filters.startDate}&endDate=${
      filters.endDate
    }`
  )
}

export function getContactsAdded(filters) {
  return request(
    `/reports/general/activity-report/contacts-added/?startDate=${filters.startDate}&endDate=${
      filters.endDate
    }`
  )
}

export function getCompaniesAdded(filters) {
  return request(
    `/reports/general/activity-report/companies-added/?startDate=${filters.startDate}&endDate=${
      filters.endDate
    }`
  )
}

export function getLeadsAdded(filters) {
  return request(
    `/reports/general/activity-report/leads-added/?startDate=${filters.startDate}&endDate=${
      filters.endDate
    }`
  )
}

export function getJobsAdded(filters) {
  return request(
    `/reports/general/activity-report/jobs-added/?startDate=${filters.startDate}&endDate=${
      filters.endDate
    }`
  )
}

export function getEstimatesAdded(filters) {
  return request(
    `/reports/general/activity-report/estimates-added/?startDate=${filters.startDate}&endDate=${
      filters.endDate
    }`
  )
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/general/activityReport.js